import { React } from "react";
import PreAssessment from "./preAssessmentStep";
import ClinicalAssessment from "./clinicalAssessmentStep";
import HealthAndWellness from "./healthAndWellnessStep";
import ReviewMedication from "./reviewMedicationStep";
import { useSelector } from "react-redux";
import Education from "./educationStep";
import Documentation from "./documentationStep";

const MedicationReview = ({}) => {
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);

  if (clinicalServiceObj === null) return null;

  const renderStep = () => {
    const step =
      clinicalServiceObj.initialAssessment.initialAssessmentForm?.currentStep ===
      0
        ? 1
        : clinicalServiceObj.initialAssessment.initialAssessmentForm
            .currentStep;
    switch (step) {
      case 1:
        return <PreAssessment />;
      case 2:
        return <ClinicalAssessment />;
      case 3:
        return <HealthAndWellness />;
      case 4:
        return <ReviewMedication />;
      case 5:
        return <Education />;
      case 6:
        return <Documentation />;
    }
  };

  return (
    <div className="bg-gray-20 flex flex-1 w-full">
      <div className="relative flex flex-col w-full gap-4 bg-white">
        <div className="flex flex-col">
          <div className="flex flex-col gap-5">{renderStep()}</div>
        </div>
      </div>
    </div>
  );
};

export default MedicationReview;
